import sdl from '@jds/react-generated-sdl/JDSBadgeV2';
import type { JDSBadgeV2Props } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBadgeV2Props) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'information',
    placement = 'top_start',
    size = 'medium',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, placement, size, ...rest },
    'JDSBadgeV2',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BadgeV2 = withLogic(Component) as React.FC<JDSBadgeV2Props> & {
  slotName?: string;
};

BadgeV2.displayName = 'BadgeV2';
BadgeV2.slotName = 'jds_badge';

export { BadgeV2, type JDSBadgeV2Props };
